<template>
  <alzata-odata-table
    ref="grid"
    clickable
    title="Veterinarians"
    endpoint="/api/v1/veterinarians"
    :columns="[
      {
        id: 'Name',
        label: 'Name',
        sortable: true,
      },
      {
        id: 'Doctor',
        label: 'Doctor',
        sortable: true,
      },
    ]"
    :actions="[
      {
        id: 'edit',
        icon: (item) => 'far/pencil',
        tooltip: 'Edit',
        default: true,
        click: show,
      },
      {
        id: 'deleteVeterinarian',
        icon: (item) => 'far/trash',
        tooltip: 'Delete',
        default: true,
        click: showDeleteVeterinarian,
      },
    ]"
  >
    <template v-slot:buttons>
      <button
        type="button"
        class="btn btn-primary btn-sm ms-1"
        @click="show({})"
      >
        <alzata-icon icon="far/plus-circle" /> Add Veterinarian
      </button>
    </template>
  </alzata-odata-table>
  <edit-veterinarian-dialog ref="editDialog" @save="save" />
  <delete-veterinarian-dialog ref="deleteVeterinarianDialog" @deleteVeterinarian="deleteVeterinarian"/>
</template>

<script>
import EditVeterinarianDialog from "@/dialogs/EditVeterinarianDialog.vue";
import DeleteVeterinarianDialog from "@/dialogs/DeleteVeterinarianDialog.vue";
export default {
  name: "VeterinarianList",
  components: {
    EditVeterinarianDialog,
    DeleteVeterinarianDialog
  },
  methods: {
    show(veterinarian) {
      this.$refs.editDialog.show(veterinarian);
    },
    async save(veterinarian) {
      const body = {
        name: veterinarian.name,
        doctor: veterinarian.doctor,
        hours: veterinarian.hours,
        address: veterinarian.address,
        phoneFriendly: veterinarian.phoneFriendly,
        phone: veterinarian.phone,
        emergencyPhoneFriendly: veterinarian.emergencyPhoneFriendly,
        emergencyPhone: veterinarian.emergencyPhone,
        email: veterinarian.email,
        website: veterinarian.website,
        isEmergency: veterinarian.isEmergency,
      };
      if (veterinarian.id) {
        await this.apiClient.putJson(
          `/api/v1/veterinarians/${veterinarian.id}`,
          { body }
        );
      } else {
        const res = await this.apiClient.postJson("/api/v1/veterinarians", {
          body,
        });
        if (!res.success) {
          alert("error saving veterinarian");
          return;
        }
        veterinarian.id = res.id;
      }

      this.$refs.grid.reload();
      this.$refs.editDialog.hideEditVeteranarian();
    },
    showDeleteVeterinarian(veterinarian) {
      this.$refs.deleteVeterinarianDialog.show(veterinarian);
    },
    async deleteVeterinarian(veterinarian) {
      await this.apiClient.doDelete(`/api/v1/veterinarians/${veterinarian.id}`, { });
      this.$refs.deleteVeterinarianDialog.hide();
      this.$refs.grid.reload();
    },
  },
};
</script>
